/**
 * Base URL of the backend API — REACT_APP_BACKEND_URL when set.
 *
 * Local development only: when it is empty, the API is assumed on the same host the
 * app was opened on, port REACT_APP_BACKEND_PORT (default 8001). So
 * http://localhost:3100 talks to http://localhost:8001 and http://10.0.0.5:3100 talks
 * to http://10.0.0.5:8001, which lets other machines on the network use the local
 * stack. Production builds keep using REACT_APP_BACKEND_URL as-is.
 */
const explicit = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
const port = process.env.REACT_APP_BACKEND_PORT || '8001';
const isLocalDev = process.env.NODE_ENV === 'development' && typeof window !== 'undefined';
// Portal addresses (admin-dev / dealer-dev / lco-dev …) serve the API themselves under /api:
// each portal then keeps its own sign-in cookie (users sign in to each portal separately).
const onPortalHost = typeof window !== 'undefined'
  && /^(admin|dealer|lco|customer)[-.]/.test(window.location.hostname)
  && !/\.localhost$/.test(window.location.hostname);

export const BACKEND_URL = explicit
  || (onPortalHost ? '' : isLocalDev ? `${window.location.protocol}//${window.location.hostname}:${port}` : '');

export default BACKEND_URL;
